import { MappedImage, SponsorModal, ModalWrapper } from "../../utils/fw"
import { AgendaSidebar } from "../components/AgendaSidebar"
import { triggerGamificationRule } from "../../utils/fw"

const between = (start, end) => new Date() > new Date(start) && new Date() < new Date(end)

export default {
	background: "https://assets.swoogo.com/uploads/full/1392099-615c90690c187.jpg",
	extras: (
		<>
			<iframe
				className="breakouts-livestream"
				src="https://livestream.com/accounts/11603075/events/9889538/player?width=640&height=360&enableInfoAndActivity=false&defaultDrawer=&autoPlay=true&mute=false"
				allowfullscreen
			/>
		</>
	),
	links: [
		{
			gameRule: "feedback-breakout-1",
			gameRuleCooldown: 1000 * 60 * 60,
			label: "Feedback",
			href: "https://isfcongress.tkeventsregistration.com/ffbr1",
			isExternal: true,
			target: "_blank",
			width: "10.4%",
			height: "9.4%",
			left: "7.1%",
			top: "31.6%",
		},
		{
			label: "Access Content & On-Demand Videos",
			href: "https://isfcongress.tkeventsregistration.com/digital2021/ondemand",
			target: "_blank",
			isExternal: true,
			width: "10.6%",
			height: "15.7%",
			left: "7.1%",
			top: "43.7%",
		},
		{
			label: "Breakout One Screen",
			width: "49%",
			height: "55.7%",
			left: "25.4%",
			top: "8.5%",
		},
		{
			label: "What's on",
			width: "12.3%",
			height: "46%",
			left: "81.7%",
			top: "13.5%",
			cursor: "default",
			children: <AgendaSidebar room="Breakout One" />
		},
		{
			label: "Roundtables",
			href: "/roundtables",
			width: "9.4%",
			height: "16.8%",
			left: "45.5%",
			top: "81.8%",
		},
	],
	name: "breakout-one",
}